import { Button, Group, Stack, Textarea } from '@mantine/core';

import { DateTimePickerInput, Select } from '@components';
import { SimulateTsdModalProps } from '@features/tsd/TSDList/CustomsSimulator/types';
import { useSimulateTsdStatusUpdateFormInitializer } from './useSimulateTsdStatusUpdateFormInitializer';

const IETS095_STATUS_OPTIONS = [
  { value: '02', label: '02 - Accepted' },
  { value: '06', label: '06 - Irregularity under investigation' },
  { value: '08', label: '08 - Under control' },
  { value: '09', label: '09 - Measures required' },
  { value: '12', label: '12 - Temporary storage ended' },
  { value: '14', label: '14 - Proof of union status validated' },
];

const IETS095_STATUS_REASON_OPTIONS = [
  { value: '03', label: '03 - Amendment irregularity' },
  { value: '04', label: '04 - Location of goods' },
  { value: '05', label: '05 - No satisfactory control result' },
  { value: '06', label: '06 - Irregularity refused' },
  { value: '07', label: '07 - Decision to end temporary storage by customs' },
  { value: '08', label: '08 - Write-off completed at timer expiration' },
  { value: '09', label: '09 - Irregularity at timer expiration' },
];

export const SimulateTsdStatusUpdate: React.FC<SimulateTsdModalProps> = ({ tsd, onHide, onSubmit }) => {
  const {
    form,
    onSubmit: onSubmitForm,
    submitting,
  } = useSimulateTsdStatusUpdateFormInitializer({
    tsd,
    onHide,
    onSubmit,
  });

  return (
    <form onSubmit={form.onSubmit(onSubmitForm)}>
      <Stack gap="sm" mb="xl">
        <Select {...form.getInputProps('status')} label="Status" placeholder="Select status" data={IETS095_STATUS_OPTIONS} allowDeselect={false} />

        <Select
          {...form.getInputProps('statusReason')}
          label="Status reason"
          placeholder="Select status reason"
          data={IETS095_STATUS_REASON_OPTIONS}
          clearable
        />

        <DateTimePickerInput {...form.getInputProps('notificationDate')} label="Notification date" placeholder="Select notification date" />

        <DateTimePickerInput {...form.getInputProps('timerForTemporaryStorage')} label="Timer for temporary storage" clearable />

        <Textarea {...form.getInputProps('remarks')} label="Remarks" placeholder="Remarks" autosize minRows={3} maxRows={5} />
      </Stack>

      <Group justify="center">
        <Button type="button" onClick={onHide} disabled={submitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="submit" loading={submitting} variant="filled" size="lg" data-pw="simulate-iets095-btn">
          Trigger
        </Button>
      </Group>
    </form>
  );
};
